import { Injectable, Injector } from '@angular/core';

import { ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';

import { BetslipOverAskRejectOfferDialogComponent } from '../components/betslip-over-ask-reject-offer-dialog.component';

@Injectable()
export class OverAskRejectOfferModalDialogService {
    private modalDialogRef: ModalRef | null = null;

    constructor(
        private modalDialogService: ModalDialogService,
        private injector: Injector,
        private epcotConfigService: EpcotConfigService,
    ) {}

    open(inColumn: boolean = false): Promise<string> {
        if (this.modalDialogRef) {
            this.close();
        }

        const epcotClass = this.epcotConfigService.isEnabled() ? 'epcot-enabled' : '';

        this.modalDialogRef = this.modalDialogService.openDialog(BetslipOverAskRejectOfferDialogComponent, {
            settings: {
                cssClass: `bet-station-modal betslip-over-ask-reject-confirm-dialog__modal betslip-vars-scope ${epcotClass}`,
                showPageHeader: true,
                isPopup: !inColumn,
                injector: this.injector,
                backdropClass: 'betslip-over-ask-reject-confirm-dialog__modal--overlay',
            },
        });

        return this.modalDialogRef.result.catch(() => 'RETURN');
    }

    close(): void {
        if (this.modalDialogRef) {
            this.modalDialogRef.dismiss('RETURN');
            this.modalDialogRef = null;
        }
    }

    isOpen(): boolean {
        return !!this.modalDialogRef;
    }
}
